export default __webpack_public_path__ + "images/IX.bd0e78d.png";